import Bugsnag from '@bugsnag/js';
import { SET_USER } from './types';
import { IAm } from '@shared/types';
import { Dispatch } from 'redux';
const { request } = require('cademy-shared-web');

const whoAmI = async () => {
    console.log('process.env.REACT_APP_API_URL', process.env.REACT_APP_API_URL);
    const data: any = await request.get('/users/iam');
    return data.data as IAm;
};

export const setUser = (iam: IAm) => {
    return {
        type: SET_USER,
        payload: iam,
    };
};

export const updateLocalAuthState = () => async (dispatch: Dispatch) => {
    try {
        const iam = await whoAmI();

        if (iam.authenticated) {
            Bugsnag.setUser(iam.userId, iam.email);
        }

        dispatch(setUser(iam));
    } catch (_error) {
        // do nothing
    }
};
